"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkCustomerExists = exports.search = exports.createDefaultCustomer = exports.fetchDefaultCustomer = exports.update = exports.create = exports.fetch = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const customerService_1 = require("./service/customerService");
const Env_1 = require("../../utils/tsUtils/Env");
exports.fetch = (0, toolkit_1.createAsyncThunk)('customer/fetch', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const customerService = new customerService_1.CustomerService(Env_1.APIPATHENV);
        const response = yield customerService.fetchCustomer(payload);
        return response;
    }
    catch (error) {
        throw new Error('Error while fetching customer');
    }
}));
exports.create = (0, toolkit_1.createAsyncThunk)('customer/create', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const customerService = new customerService_1.CustomerService(Env_1.APIPATHENV);
        const response = yield customerService.createCustomer(payload);
        return response;
    }
    catch (error) {
        throw new Error('Error while creating customer');
    }
}));
exports.update = (0, toolkit_1.createAsyncThunk)('customer/update', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const customerService = new customerService_1.CustomerService(Env_1.APIPATHENV);
        const response = yield customerService.updateCustomer(payload);
        return response;
    }
    catch (error) {
        throw new Error('Error while updating customer');
    }
}));
exports.fetchDefaultCustomer = (0, toolkit_1.createAsyncThunk)('customer/fetchDefaultCustomer', (thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const customerService = new customerService_1.CustomerService(Env_1.APIPATHENV);
        const response = yield customerService.fetchDefaultCustomer();
        return response;
    }
    catch (error) {
        throw new Error('Error while fetching customer');
    }
}));
exports.createDefaultCustomer = (0, toolkit_1.createAsyncThunk)('customer/createDefaultCustomer', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const customerService = new customerService_1.CustomerService(Env_1.APIPATHENV);
        const response = yield customerService.createDefaultCustomer(payload);
        return response;
    }
    catch (error) {
        throw new Error('Error while creating customer');
    }
}));
exports.search = (0, toolkit_1.createAsyncThunk)('customer/search', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const customerService = new customerService_1.CustomerService(Env_1.APIPATHENV);
        const response = yield customerService.searchCustomer(payload);
        return response;
    }
    catch (error) {
        throw new Error('Error while fetching customer');
    }
}));
exports.checkCustomerExists = (0, toolkit_1.createAsyncThunk)('customer/checkCustomerExists', (mobile, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const customerService = new customerService_1.CustomerService(Env_1.APIPATHENV);
        const response = yield customerService.checkCustomerExists(mobile);
        return response;
    }
    catch (error) {
        throw new Error('Error while fetching customer');
    }
}));
